import { render } from "./addParams.vue?vue&type=template&id=69586aa8"
import script from "./addParams.vue?vue&type=script&lang=js"
export * from "./addParams.vue?vue&type=script&lang=js"

import "./addParams.vue?vue&type=style&index=0&id=69586aa8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__